// extracted by css-extract-rspack-plugin
export default {"contentTitle":"contentTitle-eeHuY7"};